import { Component } from '@angular/core';
import { routeAnimations } from '../../shared/animations/router-animation';

@Component({
  selector: 'app-user-management',
  templateUrl: './warehouse-management.component.html',
  styleUrl: './warehouse-management.component.scss',
  animations: [routeAnimations]
})
export class WarehouseManagementComponent {

}
